export default __webpack_public_path__ + "static/media/jaggedcut4.857888cd.png";